import React from 'react'
import { NO_VALUE } from '../math/format'
import { DefinitionTooltip } from './definition-tooltip'
import './org-dashboard.scss'

/** The class the stylesheet's Total row rules hang on, for every dashboard table that closes with a Total row. */
export const TABLE_TOTALS_ROW_CLASS_NAME = 'org-dashboard-totals-row'

/**
 * "Total" in bold with an info icon after it, on one line so the row is no taller than a row of figures. The coverage
 * sentence lives only in the icon's tooltip and is also the icon's accessible name, so it is neither visible clutter
 * in the row nor a second copy for assistive technology.
 */
export const TotalsLabel: React.FC<{ coverage: string }> = ({ coverage }) => (
    <span className="org-dashboard-totals-label">
        <strong>Total</strong>
        <DefinitionTooltip text={coverage} accessibleName={coverage} />
    </span>
)

/** A total's figure alone: no change line and no reserved space for one. */
export const TotalsFigure: React.FC<{ text: string }> = ({ text }) => (
    <span className={text === NO_VALUE ? 'org-dashboard-dash' : undefined}>{text}</span>
)
